import { render, staticRenderFns } from "./LoginTurkuaz.vue?vue&type=template&id=5363c24b&"
import script from "./LoginTurkuaz.vue?vue&type=script&lang=js&"
export * from "./LoginTurkuaz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports